import { createSlice } from "@reduxjs/toolkit";
import {
  scanBeneficiary,
  enterBeneficiary,
  checkInvitation,
  acceptInvitation,
  refuseInvitation,
} from "../actions/initiative.actions";

const initialState = {
  // Beneficiary scan
  beneficiary: null as any,
  scanLoading: false,
  scanNotFoundMessage: null as string | null,
  entering: false,

  // Invitation accept/refuse
  invitation: null as any,
  loading: true,
  notFound: false,
  notFoundMessage: null as string | null,
  actionLoading: false,

  error: null as unknown | null,
};

export const initiativeSlice = createSlice({
  name: "initiative",
  initialState,
  reducers: {
    resetScan: (state) => {
      state.beneficiary = null;
      state.scanNotFoundMessage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(scanBeneficiary.pending, (state) => {
        state.scanLoading = true;
        state.scanNotFoundMessage = null;
      })
      .addCase(scanBeneficiary.fulfilled, (state, action) => {
        state.beneficiary = action.payload;
        state.scanLoading = false;
      })
      .addCase(scanBeneficiary.rejected, (state, action) => {
        state.beneficiary = null;
        state.scanLoading = false;
        state.scanNotFoundMessage =
          (action.payload as any)?.message ||
          "لم يتم العثور على مستفيد بهذا الباركود";
      })
      .addCase(enterBeneficiary.pending, (state) => {
        state.entering = true;
      })
      .addCase(enterBeneficiary.fulfilled, (state, action) => {
        state.entering = false;
        const result = (action.payload as any)?.result ?? action.payload;
        if (state.beneficiary) {
          state.beneficiary = { ...state.beneficiary, ...result };
        }
      })
      .addCase(enterBeneficiary.rejected, (state, action) => {
        state.entering = false;
        state.error = action.payload;
      })
      .addCase(checkInvitation.pending, (state) => {
        state.loading = true;
        state.notFound = false;
        state.notFoundMessage = null;
      })
      .addCase(checkInvitation.fulfilled, (state, action) => {
        const result = action.payload;
        if (result?.code !== undefined && result?.code !== null) {
          state.invitation = result;
          state.notFound = false;
          state.notFoundMessage = null;
        } else {
          state.invitation = null;
          state.notFound = true;
          state.notFoundMessage = result?.message || null;
        }
        state.loading = false;
      })
      .addCase(checkInvitation.rejected, (state, action) => {
        state.invitation = null;
        state.notFound = true;
        state.notFoundMessage = null;
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(acceptInvitation.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(acceptInvitation.fulfilled, (state) => {
        state.actionLoading = false;
      })
      .addCase(acceptInvitation.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.error.message;
      })
      .addCase(refuseInvitation.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(refuseInvitation.fulfilled, (state) => {
        state.actionLoading = false;
      })
      .addCase(refuseInvitation.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetScan } = initiativeSlice.actions;
export default initiativeSlice.reducer;
